import { add, format } from 'date-fns'

const lengthOfPregnancy = 266
const averageLutealPhase = 14

export const getDueDateFromLastPeriod = (date) =>
  add(date, { days: averageLutealPhase + lengthOfPregnancy })

export const getDueDateFromConceptionDate = (date) =>
  add(date, { days: lengthOfPregnancy })

export const formatDueDate = (date) => format(date, 'yyyy-MM-d')
